module.exports = __webpack_public_path__ + "img/party_bkg.95a996a6.jpg";